// import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
// import { auth,db } from "./firebaseConfig";
// import { getFirestore, collection, query, where, getDocs } from "firebase/firestore";

// import { jwtDecode } from "jwt-decode";

// function validAccount(userEmail) {
//   return userEmail.split("@")[1] === "devangles.com";
// }

// // Function to check if the user is an admin via API call
//  async function checkIsAdmin(emailId) {
//     const url = `${process.env.REACT_APP_BACKEND_URL_LMS}/check-is-admin`; // API URL
//     const requestBody = { email_id: emailId };
  
//     try {
//       const response = await fetch(url, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(requestBody),
//       });
  
//       const data = await response.json();
  
//       if (!response.ok) {
//         if (data.error === "User not allowed") {
//           alert("Please contact admin, you are not authorized.");
//           throw new Error("User not allowed"); // Stop execution
//         }
//         throw new Error(data.error || "Unknown API error");
//       }
  
//       // **Extract JWT Token**
//       const token = data.token;
//       if (!token) {
//         throw new Error("No token received from API");
//       }
  
//       //  **Store Token Securely**
//       sessionStorage.setItem("authToken", token);
//       console.log(token)
  
//       // **Decode JWT Token**
//       const decoded = jwtDecode(token);
//       console.log("i am is in the google login firebase")
//       console.log("Decoded Token: ", decoded);
  
//       return decoded; // { email, isAdmin, exp }
//     } catch (error) {
//       console.error("Request failed:", error);
//       throw error; // Ensure the error propagates
//     }
//   }

//   async function getDocumentIdByEmail(email) {
//     const usersRef = collection(db, "tbl_employee_personal_details"); // Your Firestore collection
//     const q = query(usersRef, where("Corporate_Email_ID", "==", email));

//     try {
//         const querySnapshot = await getDocs(q);
//         if (querySnapshot.empty) {
//             console.log("No matching document found.");
//             return;
//         }

//         querySnapshot.forEach((doc) => {
//             console.log("Document ID:", doc.id);
//         });
//     } catch (error) {
//         console.error("Error getting document ID:", error);
//     }
// }


// export const signInwithGoogle = async () => {
//   const provider = new GoogleAuthProvider();
//   provider.setCustomParameters({
//     hd: "devangles.com",
//   });

//   try {
//     const result = await signInWithPopup(auth, provider);
//     const userEmail = result.user.email;

//     if (!validAccount(userEmail)) {
//       getAuth(auth).signOut();
//       throw new Error("Invalid email domain");
//     }

//     console.log("User authenticated:", result.user);

//     // ✅ **Wait for the API response before proceeding**
//     const isAdmin = await checkIsAdmin(userEmail);

//     const getDocumentIdByEmail = async (email) => {
//       const usersRef = collection(db, "tbl_employee_personal_details");
//       const q = query(usersRef, where("Corporate_Email_ID", "==", email));

//       try {
//         const querySnapshot = await getDocs(q);
//         if (querySnapshot.empty) {
//           console.log("No matching document found.");
//           return null;
//         }

//         let docId = null;
//         querySnapshot.forEach((doc) => {
//           console.log("Document ID:", doc.id);
//           docId = doc.id; // Store the first document ID found
//         });

//         if (docId) {
//           localStorage.setItem("documentId", docId); // Store in localStorage
//         }

//         return docId;
//       } catch (error) {
//         console.error("Error getting document ID:", error);
//       }
//     };

//     const documentId = await getDocumentIdByEmail(userEmail);

//     // ✅ **Store user access level**
//     localStorage.setItem("UserEmail", userEmail);
//     localStorage.setItem("AccessLevel", isAdmin ? "admin" : "employee");

//     console.log(`User role: ${isAdmin ? "Admin" : "Employee"}`);
//     console.log("Document ID Stored:", documentId);
//     return result.user;
//   } catch (error) {
//     console.error("Login failed:", error.message);
//     getAuth(auth).signOut(); // Ensure user is logged out on failure
//   }
// };


import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { auth, db } from "./firebaseConfig";
import { collection, query, where, getDocs } from "firebase/firestore";
import { jwtDecode } from "jwt-decode";

function validAccount(userEmail) {
  return userEmail.split("@")[1] === "devangles.com";
}

async function checkIsAdmin(emailId) {
  const url = `${process.env.REACT_APP_BACKEND_URL_LMS}/check-is-admin`;
  const requestBody = { email_id: emailId };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestBody),
    });

    const data = await response.json();

    if (!response.ok) {
      if (data.error === "User not allowed") {
        alert("Please contact admin, you are not authorized.");
        throw new Error("User not allowed");
      }
      throw new Error(data.error || "Unknown API error");
    }

    const token = data.token;
    if (!token) {
      throw new Error("No token received from API");
    }

    sessionStorage.setItem("authToken", token);
    return jwtDecode(token);
  } catch (error) {
    console.error("Request failed:", error);
    throw error;
  }
}

export const signInwithGoogle = async () => {
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({
    hd: "devangles.com",
  });

  try {
    // Ensure auth is properly initialized
    if (!auth) {
      throw new Error("Firebase Auth not initialized");
    }

    const result = await signInWithPopup(auth, provider);
    localStorage.setItem("emsUser", JSON.stringify(result));
    const userEmail = result.user.email;

    if (!validAccount(userEmail)) {
      await auth.signOut();
      throw new Error("Invalid email domain");
    }

    // console.log("User authenticated:", result.user);

    const isAdmin = await checkIsAdmin(userEmail);

    const getDocumentIdByEmail = async (email) => {
      const usersRef = collection(db, "tbl_employee_personal_details");
      const q = query(usersRef, where("Corporate_Email_ID", "==", email));

      try {
        const querySnapshot = await getDocs(q);
        if (querySnapshot.empty) return null;

        let docId = null;
        querySnapshot.forEach((doc) => {
          docId = doc.id;
        });

        if (docId) {
          localStorage.setItem("documentId", docId);
        }

        return docId;
      } catch (error) {
        console.error("Error getting document ID:", error);
        return null;
      }
    };

    const documentId = await getDocumentIdByEmail(userEmail);

    localStorage.setItem("UserEmail", userEmail);
    localStorage.setItem("AccessLevel", isAdmin ? "admin" : "employee");

    return {
      user: result.user,
      role: isAdmin ? "admin" : "employee",
      photo: result.user.photoURL,
      name: result.user.displayName,
      email: result.user.email
    };
  } catch (error) {
    console.error("Login failed:", error.message);
    if (auth) {
      await auth.signOut();
      localStorage.removeItem("emsUser");
    }
    throw error;
  }
};